// 创建 WeakMap 存储元素和动画状态
const elMap = new WeakMap();
export default {
  inserted(el, binding) {
    const options = binding.value || {};
    const {
      animation = "fadeInUp",
      threshold = 0.1,
      offset = 50,
      duration = 1000,
      delay = 0,
      observerOnce = true,
    } = options;

    // 配置 IntersectionObserver
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 添加动画类
            el.classList.add(
              //   "animate__animated",
              "animated",
              //   `animate__${binding.value}`,
              `${options.animation}`
            );
            if (options.delay) {
              el.style.animationDelay = `${options.delay}ms`; // 设置动画延迟时间
            }
            if (options.duration) {
              el.style.animationDuration = `${options.duration}ms`; // 设置动画持续时间
            }
            const handleAnimationEnd = () => {
              if (!observerOnce) {
                el.classList.remove("animated", `${animation}`);
                el.style.animationDelay = "";
              }
              el.removeEventListener("animationend", handleAnimationEnd);
            };
            el.addEventListener("animationend", handleAnimationEnd);
            if (options.observerOnce) {
              observer.unobserve(el);
            }
          }
        });
      },
      {
        threshold: 0.1, // 元素10%进入视口时触发
        rootMargin: "0px 0px -50px 0px", // 底部提前50px触发
      }
    );

    // 存储观察器实例
    elMap.set(el, observer);

    // 初始隐藏元素
    // el.style.opacity = 0;

    // 开始观察元素
    observer.observe(el);
  },
  unbind(el) {
    // 清理观察器
    const observer = elMap.get(el);
    if (observer) {
      observer.disconnect();
      elMap.delete(el);
    }
  },
};
